import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7742189b")
const _hoisted_1 = { class: "_header" }
const _hoisted_2 = { class: "_headerBack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, " History ", -1)
const _hoisted_4 = {
  key: 0,
  class: "_main"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "_subheader" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Game history")
], -1)
const _hoisted_6 = {
  key: 1,
  id: "history",
  class: "_main"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "_subheader" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Game history")
], -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "summary" }
const _hoisted_10 = { class: "text" }
const _hoisted_11 = { class: "header" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Host", -1)
const _hoisted_15 = {
  key: 1,
  class: "row"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", null, "Performance", -1)
const _hoisted_17 = {
  key: 2,
  class: "row"
}
const _hoisted_18 = {
  key: 3,
  class: "row"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", null, "Game deleted as no active players", -1)
const _hoisted_20 = [
  _hoisted_19
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconButton, {
          icon: "back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app/'}))),
          white: true
        })
      ]),
      _hoisted_3
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_LoadSpinner, { text: "Loading" })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _hoisted_7,
          (!_ctx.historyFields.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " You haven't joined or finished any games. "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyFields, (game) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "historyItem",
                key: game.id
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", null, _toDisplayString(game.meta.title || _ctx.getGame(game)), 1),
                    (game.started)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Started: " + _toDisplayString(_ctx.getTime(game.started)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (game.time || game.complete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("p", null, _toDisplayString(game.meta.hostName || _ctx.getHost(game)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (game.time || game.complete)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("p", null, "Time: " + _toDisplayString(_ctx.timeLeft(game.time/1000)), 1),
                        _createElementVNode("p", null, "Players: " + _toDisplayString(game.lobbySize), 1),
                        _createElementVNode("p", null, "Skips: " + _toDisplayString(game.skips), 1),
                        _createElementVNode("p", null, "Hints: " + _toDisplayString(game.hints), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!game.deleted && !game.time)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_IconButton, {
                          icon: "forward",
                          text: "Game playing",
                          onClick: ($event: any) => (_ctx.$router.push({path:`/app/lobby/${game.meta.gameId}/${game.meta.code}`}))
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true),
                  (game.deleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}